// i.e. no metadata has been set
export const META_ATTACH_STATE_NONE = 'META_ATTACH_STATE_NONE';
// i.e. metadata has been attached and is awaiting for attaching
export const META_ATTACH_STATE_READY = 'META_ATTACH_STATE_READY';
// i.e. when attaching is in progress
export const META_ATTACH_STATE_IN_PROGRESS = 'META_ATTACH_STATE_IN_PROGRESS';
export const META_ATTACH_STATE_SUCCESS = 'META_ATTACH_STATE_SUCCESS';
export const META_ATTACH_STATE_FAILURE = 'META_ATTACH_STATE_FAILURE';



// WEBPACK FOOTER //
// ./src/js/constants/metaAttachStates.js